import { render, staticRenderFns } from "./UserRevisions.vue?vue&type=template&id=2c48cc59&scoped=true&"
import script from "./UserRevisions.vue?vue&type=script&lang=js&"
export * from "./UserRevisions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c48cc59",
  null
  
)

export default component.exports